function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f0efef;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_874",
  className: "cls-1",
  d: "M19.194,40.6l2.237-2.237a2.408,2.408,0,0,1,3.416,0L44.433,57.937a2.408,2.408,0,0,1,0,3.416L24.846,80.94a2.408,2.408,0,0,1-3.416,0L19.194,78.7a2.421,2.421,0,0,1,.04-3.456L31.375,63.68H-117.582A2.412,2.412,0,0,1-120,61.262V58.038a2.412,2.412,0,0,1,2.418-2.418H31.375L19.234,44.053A2.4,2.4,0,0,1,19.194,40.6Z",
  transform: "translate(120 -37.65)"
});

var SvgArrowLong = function SvgArrowLong(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165.143,
    height: 44,
    viewBox: "0 0 165.143 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLong, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-long.32e6e6b8.svg";
export { ForwardRef as ReactComponent };